import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter, WindowRef } from '@spartacus/core'
import { Facet } from 'smartsearch.js'
import { CmsConverterService, defaultTextInput } from '../../../services/cms-converter/cms-converter.service'
import { CmsDOMInputParser } from '../../../../shared/utils/cms-dom-input-parser'
import { CmsSearchService } from '../cms-search.service'
import { ConvertedComponentData, Image, TextInput } from '../../types'
import { ListType } from '../../../enums/list-type'
import { CmsListFlexType } from '../../../enums/cms-list-flex-type'

@Injectable({ providedIn: 'root' })
export class CmsListConverter extends CmsConverterService<CmsListData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const listType = getListType(formData.st_options?.value?.identifier, (source as any).flexType)
    const title = formData.st_image_title?.value
    const altText = formData.image_alt?.value
    const lazyLoad = formData.image_lazy_loading?.value
    return {
      facets: this.cmsSearchService.mapReadonlyFacetsToFacets(formData.pt_tags ?? []),
      hideInitially: formData.st_initially_hide?.value ?? false,
      disableAutocomplete: formData.st_disable_autocomplete?.value ?? false,
      additionalInfo: formData?.st_keywords_or_description?.value?.identifier ?? 'description',
      listType,
      flexType: getFlexType(listType),
      headline: formData.st_headline ?? defaultTextInput,
      image: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title)
    }
  }

  constructor (protected domInputParser: CmsDOMInputParser,
               private cmsSearchService: CmsSearchService,
               protected winRef: WindowRef) {
    super(domInputParser, winRef)
  }
}

export const CMS_LIST_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, CmsListData>>('CmsListConverter')

export interface CmsListData extends ConvertedComponentData {
  facets?: Facet[];
  hideInitially?: boolean;
  disableAutocomplete?: boolean;
  additionalInfo?: string;
  listType?: string;
  headline?: TextInput;
  image?: Image;
  flexType: string;
}

const getListType = (option: string | undefined, flexType: string): string => {
  if (flexType === 'job_search') {
    return ListType.JOB
  }
  switch (option) {
    case 'clinical-changes':
      return ListType.CCN
    case 'certificates':
      return ListType.CERT
    case 'documents':
      return ListType.DOCUMENT
    default:
    case 'content':
      return ListType.CONTENT
  }
}

const getFlexType = (listType: ListType): string => {
  switch (listType) {
    case ListType.CCN:
      return CmsListFlexType.CCN
    case ListType.CERT:
      return CmsListFlexType.CERT
    case ListType.JOB:
      return CmsListFlexType.JOB
    case ListType.DOCUMENT:
      return CmsListFlexType.DOCUMENT
    default:
    case ListType.CONTENT:
      return CmsListFlexType.CONTENT
  }
}
